import { RewardTypeEnum } from "@/types/reward";

// 欢迎礼包-Welcome Bonus、累充转盘-Deposit & Spin、现金返还-Cashback、每周奖励-Weekly Bonus、每月奖励-Monthly Bonus、裂变转盘-Turntable
export const RewardTypeTextMap: Partial<Record<RewardTypeEnum, string>> = {
  [RewardTypeEnum.WELCOME_GIFT]: 'Welcome Bonus',
  [RewardTypeEnum.CASH_BACK]: 'Cashback',
  [RewardTypeEnum.WEEKLY_REWARD]: 'Weekly Bonus',
  [RewardTypeEnum.MONTHLY_REWARD]: 'Monthly Bonus',
  [RewardTypeEnum.CUMULATIVE_REWARD]: 'Deposit & Spin',
  [RewardTypeEnum.TURNTABLE_REWARD]: 'Turntable',
  [RewardTypeEnum.INVITE_REWARD]: 'Invite Reward',
};